var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5H3C2.72386 5.5 2.5 5.72386 2.5 6V8C2.5 8.27614 2.72386 8.5 3 8.5H14C14.2761 8.5 14.5 8.27614 14.5 8V6C14.5 5.72386 14.2761 5.5 14 5.5Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.5V13C13.5 13.1326 13.4473 13.2598 13.3536 13.3536C13.2598 13.4473 13.1326 13.5 13 13.5H4C3.86739 13.5 3.74021 13.4473 3.64645 13.3536C3.55268 13.2598 3.5 13.1326 3.5 13V8.5",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5V13.5",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3284 4.79443C10.6213 5.50154 8.5 5.50154 8.5 5.50154C8.5 5.50154 8.5 3.38022 9.20711 2.67311C9.48847 2.39207 9.86991 2.23426 10.2676 2.23438C10.6653 2.23449 11.0466 2.39251 11.3278 2.67371C11.609 2.95491 11.7671 3.33627 11.7672 3.73395C11.7673 4.13163 11.6095 4.51307 11.3284 4.79443V4.79443Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67311 4.79443C6.38022 5.50154 8.50154 5.50154 8.50154 5.50154C8.50154 5.50154 8.50154 3.38022 7.79443 2.67311C7.51307 2.39207 7.13163 2.23426 6.73395 2.23438C6.33627 2.23449 5.95492 2.39251 5.67372 2.67371C5.39252 2.95491 5.23449 3.33627 5.23438 3.73395C5.23426 4.13163 5.39207 4.51307 5.67311 4.79443V4.79443Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.e4a9042cf0f2a7413d9ea343eda4217f.svg";
export { ForwardRef as ReactComponent };